export default __webpack_public_path__ + "static/media/avatar-hiro.f2701624.webp";